/** Converts persisted leave status to user-facing label. Pass full `leave` to show cancellation-pending on approved rows. */
export function formatLeaveStatusLabel(statusOrLeave) {
  const leave =
    typeof statusOrLeave === "object" && statusOrLeave !== null ? statusOrLeave : null;
  const s = String((leave ? leave.status : statusOrLeave) || "").toLowerCase();
  if (!s) return "";
  if (s === "cancelled") return "Cancelled";
  if (
    s === "approved" &&
    String(leave?.cancelRequestStatus || "").toLowerCase() === "pending"
  ) {
    return "Approved · Cancellation pending";
  }
  return s.charAt(0).toUpperCase() + s.slice(1);
}

/** Status label for approver / HR lists when a manager has acted but HR has not finalized yet. */
export function formatApproverLeaveStatusLabel(leave) {
  if (!leave) return "";
  if (
    String(leave.status || "").toLowerCase() === "approved" &&
    String(leave.cancelRequestStatus || "").toLowerCase() === "pending"
  ) {
    return "Cancellation pending";
  }
  const s = leave.status;
  if (s !== "pending" || !leave.managerStatus) {
    return formatLeaveStatusLabel(leave);
  }
  const name =
    `${leave.managerActionFirstname || ""} ${leave.managerActionLastname || ""}`.trim() || "Approver";
  const ms = leave.managerStatus;
  return `${ms.charAt(0).toUpperCase() + ms.slice(1)} (${name})`;
}

export function approverLeaveStatusBadgeClass(leave) {
  const s = leave.status;
  if (s === "cancelled") return "bg-slate-100 text-slate-700";
  if (
    s === "approved" &&
    String(leave.cancelRequestStatus || "").toLowerCase() === "pending"
  ) {
    return "bg-orange-100 text-orange-900";
  }
  if (s === "approved") return "bg-green-100 text-green-800";
  if (s === "rejected") return "bg-red-100 text-red-800";
  if (s === "pending" && leave.managerStatus === "approved") return "bg-amber-100 text-amber-800";
  if (s === "pending" && leave.managerStatus === "rejected") return "bg-orange-100 text-orange-800";
  return "bg-yellow-100 text-yellow-800";
}
